export enum ProduceButtonsPageViewMode {
  ViewAllButtons = "ViewAllButtons",
  ViewButtonsOfToday = "ViewButtonsOfToday",
}
